<template>
  <div
    id="header"
    class="home-header"
    :class="[{ specialClass: $route.name != 'home' || isScroll }]"
  >
    <header class="header-wrap">
      <router-link to="/" class="logo-wrap" title="锐仕校园-首页">
        <img src="../assets/img/logo.png" class="logo" alt="" />
      </router-link>
      <ul class="header-list">
        <li class="header-link">
          <router-link to="/" class="header-a">首页</router-link>
        </li>
        <li class="header-link">
          <router-link to="/search" class="header-a">找职位</router-link>
        </li>
        <li class="header-link">
          <router-link to="/wellcompany" class="header-a">名企校招</router-link>
        </li>
      </ul>
      <div class="header-r">
        <a
          href="http://school-admin.risfond.com/"
          target="_blank"
          class="header-r-link"
          >企业入口</a
        >
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      isScroll: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.whenScroll);
  },

  methods: {
    whenScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 1) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
  },
};
</script>

<style scoped>
#header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 64px;
  padding: 8px 0;
}
.home-header {
  background: transparent;
}
.specialClass {
  background: #272e3e;
}
.header-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.logo-wrap {
  width: 137px;
  height: 35px;
}
.logo {
  width: 100%;
  height: 100%;
}
.header-list {
  display: flex;
  margin-left: 80px;
}
.header-link {
  padding: 0 26px;
}
.header-a {
  color: #ffffff;
  font-size: 18px;
  padding: 4px 0;
  position: relative;
}
.header-a:hover::before,
.header-link .router-link-exact-active::before {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  background: #ffffff;
  border-radius: 2px;
  content: "";
}
.header-r {
  position: absolute;
  right: 0;
}
.header-r-link {
  background: #3b87ff;
  color: #fff;
  padding: 8px 24px;
  border-radius: 17px;
}
</style>
